<template>
  <Dialog v-model:visible="fileUploadVisible" modal header="Subir archivo" :style="{ width: '35rem' }">
    <div class="flex flex-col items-center gap-4 mb-4">

      <div class="w-full" v-if="askDescription">
        <label class="block mb-1">Descripción</label>
        <InputText v-model="descripcion" maxlength="20" placeholder="Ingrese una descripción" class="input-base bg-gray-50 input-success" />
      </div>

      <label class="w-full px-3 py-2 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white text-center cursor-pointer">
        <i class="pi pi-upload mr-2"></i>
        {{ fileName || 'BUSCAR ARCHIVO' }}
        <input @change="handleBackgroundFileUpload" type="file" class="hidden" :accept="acceptedFileTypes" />
      </label>

    </div>
    <div v-if="uploadError" class="text-red-500 mb-4">{{ uploadError }}</div>
    <div class="flex justify-end gap-2">
      <button type="button" @click="fileUploadVisible = false" class="px-3 py-2 border border-red-500 text-red-500 rounded hover:bg-red-500 hover:text-white">
        <i class="pi pi-times"></i>
        CANCELAR
      </button>
      <button type="button" @click="handleAccept" class="px-3 py-2 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white cursor-pointer">
        <i class="pi pi-check"></i>
        ACEPTAR
      </button>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";

export default defineComponent({
  components: {
    Dialog, InputText
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    askDescription: {
      type: Boolean,
      required: true
    },
    forceSquare: {
      type: Boolean,
      default: true
    },
    maxSizeMB: {
      type: Number,
      required: true
    },
    fileTypes: {
      type: Array as PropType<string[]>,
      required: true
    },
    onAccept: {
      type: Function,
      required: true
    }
  },  
  watch: {
    visible(newVal) {
      this.descripcion = "";
      this.fileName = "";
      this.fileUploadVisible = newVal;
    },
    fileUploadVisible(newVal) {
      this.$emit('update:visible', newVal);
    }
  },
  computed: {
    acceptedFileTypes() {
      return this.fileTypes.join(',');
    }
  },
  data() {
    return {
      descripcion: '',
      fileUploadVisible: false,
      isFileValid: false,
      uploadError: '',
      archivoBase64: '',
      fileName: ''
    };
  },
  methods: {
    createBase64Image(fileObject: File): void {
      const reader = new FileReader();      
      reader.onload = (event: ProgressEvent<FileReader>) => {
        this.archivoBase64 = event.target?.result as string;
        
      };
      reader.readAsDataURL(fileObject);
    },
    handleAccept() {
      if(!this.descripcion && this.askDescription) {
        this.uploadError = "Debe ingresar una descripción";
        return;
      }

      if (!this.isFileValid) {
        if(!this.uploadError) {
          this.uploadError = "Debe seleccionar un archivo válido";
        }
        this.isFileValid = false;
        return;
      }

      if (this.isFileValid) {
        if (this.onAccept) {
          if(this.askDescription) {
            this.onAccept(this.archivoBase64, this.fileName, this.descripcion);
          } else {
            this.onAccept(this.archivoBase64, this.fileName);
          }
        }
        this.fileUploadVisible = false;
      }
    },
  
    handleBackgroundFileUpload(event: Event) {
      const input = event.target as HTMLInputElement;
      if (!input.files || input.files.length === 0) {
        this.uploadError = 'No se ha seleccionado ningún archivo.';
        this.isFileValid = false;
        return;
      }

      const file = input.files[0];
      this.fileName = input.files[0].name;

      // Tipo de archivo
      if (!this.fileTypes.includes(file.type)) {
        this.uploadError = `Sólo se permiten archivos de tipo: ${this.fileTypes.join(', ')}.`;
        this.isFileValid = false;
        return;
      }

      // Tamaño del archivo
      if (file.size > this.maxSizeMB * 1024 * 1024) {
        this.uploadError = `El archivo debe ser menor de ${this.maxSizeMB} MB.`;
        this.isFileValid = false;
        return;
      }

      if (file.type === 'application/pdf') {
        // Si el archivo es un PDF
        const reader = new FileReader();
        reader.onload = () => {
          const base64PDF = reader.result as string;
          this.uploadError = '';
          this.isFileValid = true;
          this.archivoBase64  = base64PDF;
        };
        reader.onerror = () => {
          this.uploadError = 'Ocurrió un error al leer el archivo PDF.';
          this.isFileValid = false;
        };
        reader.readAsDataURL(file);
      } else {
          const img = new Image();
          img.onload = () => {

            if ((img.width !== img.height) && this.forceSquare) {
              this.uploadError = 'La imagen debe ser cuadrada.';
              this.isFileValid = false;
              return;
            }

            this.uploadError = '';
            this.isFileValid = true;
            this.createBase64Image(file);
          };

          img.onerror = () => {
            this.uploadError = 'El archivo seleccionado no es una imagen válida.';
            this.isFileValid = false;
          };

          img.src = URL.createObjectURL(file);
        }
    }
  }
});
</script>
